module.exports = __webpack_public_path__ + "img/MQ.55df0a2e.svg";